import { useState } from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { offers } from '../mock';
import PaymentModal from './PaymentModal';

const Offers = () => {
  const [modalOfferId, setModalOfferId] = useState(null);

  return (
    <section id="offers" className="section">
      <div className="reveal-target">
        <span className="section-eyebrow">Nos offres</span>
        <h2 className="section-title">
          Deux formules, <em>zero</em> compromis.
        </h2>
        <p className="section-desc">
          Chaque projet démarre avec un acompte de 40% pour lancer la production. Le solde de 60% est versé à la livraison de votre site.
        </p>
      </div>

      <div className="offers-grid">
        {offers.map((o, idx) => {
          const deposit = Math.round(o.price * 0.4);
          return (
            <div key={o.id} className={`offer-card${idx === 1 ? ' featured' : ''}`}>
              <h3 className="offer-name">{o.name}</h3>
              <p className="offer-tagline">{o.tagline}</p>
              <div className="offer-price">
                <span className="amount">{o.price}</span>
                <span className="currency">€</span>
              </div>
              <div className="offer-deposit">Acompte 40% → {deposit}€ pour démarrer</div>
              <p className="offer-desc">{o.description}</p>
              <ul className="offer-features">
                {o.features.map((f, i) => (
                  <li key={i}><Check size={16} strokeWidth={2.4} /> {f}</li>
                ))}
              </ul>
              <button
                type="button"
                className="offer-cta"
                onClick={() => setModalOfferId(o.id)}
              >
                Payer l'acompte de {deposit}€ <ArrowRight size={16} />
              </button>
            </div>
          );
        })}
      </div>

      <PaymentModal
        open={!!modalOfferId}
        offerId={modalOfferId}
        onClose={() => setModalOfferId(null)}
      />
    </section>
  );
};

export default Offers;
